import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import { Input } from "components/bootstrap";
import FormDataContext from "integrations/contexts/FormDataContext";
import { AdvancedOptionsContext } from "integrations/aws/context/AdvancedOptions";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
const FormAdvancedOptions = ({ onChange }) => {
  const { t } = useTranslation("integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const {
    awsCloudWatchBatchSize,
    overrideSource,
    awsCloudWatchThrottleEnabled,
    awsCloudWatchAddFlowLogPrefix,
    awsCloudWatchStoreFullMessage
  } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("aws_cloudwatch_advanced_options.title"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(
      ThrottlingCheckbox,
      {
        id: "awsCloudWatchThrottleEnabled",
        defaultChecked: awsCloudWatchThrottleEnabled == null ? void 0 : awsCloudWatchThrottleEnabled.value,
        onChange
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "awsCloudWatchAddFlowLogPrefix",
        type: "checkbox",
        value: "enable-logprefix",
        defaultChecked: awsCloudWatchAddFlowLogPrefix && awsCloudWatchAddFlowLogPrefix.value,
        onChange,
        label: t("aws_cloudwatch_advanced_options.flow_log_prefix_label"),
        help: t("aws_cloudwatch_advanced_options.flow_log_prefix_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "awsCloudWatchStoreFullMessage",
        type: "checkbox",
        value: "enable-store-full-message",
        defaultChecked: awsCloudWatchStoreFullMessage == null ? void 0 : awsCloudWatchStoreFullMessage.value,
        onChange,
        label: t("aws_cloudwatch_advanced_options.store_full_message_label"),
        help: t("aws_cloudwatch_advanced_options.store_full_message_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "overrideSource",
        type: "text",
        value: overrideSource == null ? void 0 : overrideSource.value,
        onChange,
        label: t("aws_cloudwatch_advanced_options.override_source_label"),
        help: t("aws_cloudwatch_advanced_options.override_source_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "awsCloudWatchBatchSize",
        type: "number",
        value: awsCloudWatchBatchSize.value || awsCloudWatchBatchSize.defaultValue,
        onChange,
        label: t("aws_cloudwatch_advanced_options.batch_size_label"),
        help: t("aws_cloudwatch_advanced_options.batch_size_help")
      }
    )
  );
};
export default FormAdvancedOptions;
